import api from '@/api'
export default {
    namespaced: true,
    state: {
        total:0,
        goodsarr:[],
        editdata:{},
        title:''
    },
    getters: {
    },
    mutations: {
        //存储用户信息
        SET_GOODSLIST: (state, obj) => {

            state.total = obj.total
            state.goodsarr=[...obj.data]
        },
        SET_EDITDATA: (state, obj) => {

            state.editdata={...obj}
        },
        SET_TITLE: (state, title) => {

            state.title=title
        },
        DEL_DATA: (state, index) => {
            state.goodsarr.splice(index,1)
        },
        CLEAR_GOODSLIST: (state) => {

            state.total = 0
            state.goodsarr=[]

        },


    },
    actions: {
        async getGoodslist({ commit },params={page:1}) {
            
            let {code,message,data}=await api.getgoodslist(params)
            if (code == 200) {
                commit('SET_GOODSLIST', data);
                return data;
            } else {
                return Promise.reject(new Error(message));
            }
        },
    },
}